import React from 'react';
import ServerPaginatedTable from '../utils/pagination.server';
import PdfIcon from 'react-icons/lib/md/picture-as-pdf'
import ExcelIcon from 'react-icons/lib/md/insert-drive-file';
import ToolTipItem from "../utils/tooltip";
import { appHelpers } from '../../_helpers';
import PageEmptyContent from "../utils/page.empty-content";
import {
    Card, CardBody, CardGroup
} from 'reactstrap';
import IconAirlineSeat from 'react-icons/lib/md/airline-seat-recline-normal';
import IconPayment from 'react-icons/lib/md/credit-card';
import IconMdAirplaneModeActive from 'react-icons/lib/md/airplanemode-active';

const Aggregate =({data,downloadPdf,downloadExcel})=>(
    <div>
        <CardGroup className="sales-card mb-4">
            <Card style={{'flex': '1.5 0 0'}}>
                <CardBody  className="justify-content-between fit">
                    <h6 className="text-uppercase title font-weight-bold small">Airline</h6>
                    <h4 className="font-weight-normal mb-0">
                        <IconMdAirplaneModeActive size="30" color="#43a8df"/>&nbsp;
                        {data.AirlineName}
                    </h4>
                </CardBody>
            </Card>
            <Card>
                <CardBody className={'fit'}>
                    <h6 className="text-uppercase title font-weight-bold small">Total Pax per Month</h6>
                    <h4 className="font-weight-normal mb-0">
                        <IconAirlineSeat size="30" color="#10324f"/>&nbsp;
                        {appHelpers.numberWithCommasOnly(data.TotalPaxCount)}
                    </h4>
                </CardBody>
            </Card>
            <Card style={{'flex': '1.5 0 0'}}>
                <CardBody className={'fit'}>
                    <h6 className="text-uppercase title font-weight-bold small">Total Payment per Month</h6>
                    <h4 className="font-weight-normal mb-0">
                        <IconPayment size="30" color="#00897b"/>&nbsp;
                        {appHelpers.numberWithCommasOnly(data.TotalInvoiceAmount)}
                    </h4>
                </CardBody>
            </Card>
            <Card style={{'flex': '1.5 0 0'}}>
                <CardBody className={'fit'}>
                    <h6 className="text-uppercase title font-weight-bold small">Download Report</h6>
                    <h4 className="font-weight-normal mb-0">
                        <span className="pointer" onClick={downloadPdf}>
                            <ToolTipItem key={'downloadPdfIcon'} title={<PdfIcon size="30" color="#e53335" className="icon-picture-as-pdf"/>} content='Download As PDF' id={'downloadPdfIcon'}/>
                        </span>&nbsp;
                        <span className="pointer" onClick={downloadExcel}>
                            <ToolTipItem key={'downloadExcelIcon'} title={<ExcelIcon size="30" color="#00897b" className="icon-insert-drive-file"/>} content='Download As Excel' id={'downloadExcelIcon'}/>
                        </span>
                    </h4>
                </CardBody>
            </Card>
        </CardGroup>
    </div>
);
const DataTable = ({data,downloadPdf,downloadExcel}) =>{
    return (data.TotalCount === 0 ) ?
        (<PageEmptyContent message='No record match your search!'/>) :
        (
            <div className="view">
                <Aggregate data={data} downloadPdf={downloadPdf} downloadExcel={downloadExcel}/>

                <div className="table-responsive">
                    <table className="table table-striped table-hover">
                        <thead>
                        <tr>

                            <th>
                                <span>Source Airport</span>
                            </th>
                            <th >
                                <span>Month</span>
                            </th>
                            <th>
                                <span>Week 1</span>
                            </th>
                            <th>
                                <span>Week 2</span>
                            </th>
                            <th>
                                <span>Week 3</span>
                            </th>
                            <th>
                                <span>Week 4 </span>
                            </th>
                            <th>
                                <span>Week 5</span>
                            </th>
                            <th>
                                <span> Total Invoice Amount</span>
                            </th>
                            <th>
                                <span>Total PAX Count</span>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {data.Results.map((item,index) => (
                            <tr key={index}>
                                <td className="text-capitalize">{item.SourceAirportName}</td>
                                    <td className="text-capitalize">{item.Month}</td>
                                <td className="text-capitalize">
                                    <span style={{ color: "#00c853", fontSize: "15px"}}>&#8358; </span>
                                    <span className="pointer">
                                            <ToolTipItem key={'Week1InvoiceAmount'} title={appHelpers.numberWithCommasOnly(item.Week1InvoiceAmount)} content='Week1 Invoice Amount' id={'Week1InvoiceAmount'}/>
                                        </span>  |
                                  <span className="pointer">
                                            <ToolTipItem key={'Week1PaxCount'} title={item.Week1PaxCount} content='Week1 Total Passenger Count' id={'Week1PaxCount'}/>
                                        </span>
                                </td>
                                <td className="text-capitalize">
                                    <span style={{ color: "#00c853", fontSize: "15px"}}>&#8358; </span>
                                    <span className="pointer">
                                            <ToolTipItem key={'Week2InvoiceAmount'} title={appHelpers.numberWithCommasOnly(item.Week2InvoiceAmount)} content='Week2 Invoice Amount' id={'Week2InvoiceAmount'}/>
                                        </span>  |
                                    <span className="pointer">
                                            <ToolTipItem key={'Week2PaxCount'} title={item.Week2PaxCount} content='Week2 Total Passenger Count' id={'Week2PaxCount'}/>
                                        </span>
                                </td>
                                <td className="text-capitalize">
                                    <span style={{ color: "#00c853", fontSize: "15px"}}>&#8358; </span>
                                    <span className="pointer">
                                            <ToolTipItem key={'Week3InvoiceAmount'} title={appHelpers.numberWithCommasOnly(item.Week3InvoiceAmount)} content='Week3 Invoice Amount' id={'Week3InvoiceAmount'}/>
                                        </span>  |
                                    <span className="pointer">
                                            <ToolTipItem key={'Week3PaxCount'} title={item.Week3PaxCount} content='Week3 Total Passenger Count' id={'Week3PaxCount'}/>
                                        </span>
                                </td>
                                <td className="text-capitalize">
                                    <span style={{ color: "#00c853", fontSize: "15px"}}>&#8358; </span>
                                    <span className="pointer">
                                            <ToolTipItem key={'Week4InvoiceAmount'} title={appHelpers.numberWithCommasOnly(item.Week4InvoiceAmount)} content='Week4 Invoice Amount' id={'Week4InvoiceAmount'}/>
                                        </span>  |
                                    <span className="pointer">
                                            <ToolTipItem key={'Week4PaxCount'} title={item.Week4PaxCount} content='Week4 Total Passenger Count' id={'Week4PaxCount'}/>
                                        </span>
                                </td>
                                <td className="text-capitalize">
                                    <span style={{ color: "#00c853", fontSize: "15px"}}>&#8358; </span>
                                    <span className="pointer">
                                            <ToolTipItem key={'Week5InvoiceAmount'} title={appHelpers.numberWithCommasOnly(item.Week5InvoiceAmount)} content='Week5 Invoice Amount' id={'Week5InvoiceAmount'}/>
                                        </span>  |
                                    <span className="pointer">
                                            <ToolTipItem key={'Week5PaxCount'} title={item.Week5PaxCount} content='Week5 Total Passenger Count' id={'Week5PaxCount'}/>
                                        </span>
                                </td>
                                        <td className="text-capitalize"><span><span style={{ color: "#00c853", fontSize: "15px"}}>&#8358; </span> {appHelpers.numberWithCommasOnly(item.InvoiceAmount)} </span></td>
                                        <td className="text-capitalize"><span>{item.PaxCount} </span> </td>
                            </tr>
                            )
                        )}
                        </tbody>
                    </table>
                </div>
            </div>
        )
}

class PaginatedResult extends React.Component {
    render() {
        const {pageSize, currentPage,navigate,data,downloadPdf,downloadExcel} = this.props;
        return (
            <div>
                <div className="row">
                    <div className="col-md-12 col-sm-12 mb-4" >
                        <ServerPaginatedTable  currentPage={currentPage} fetchMore={navigate} target={<DataTable data={data}  downloadPdf={downloadPdf} downloadExcel={downloadExcel}/>} pageSize={pageSize}/>
                    </div>
                </div>
            </div>
        );
    }
}

export default PaginatedResult



// WEBPACK FOOTER //
// ./src/views/oldBilledPerAirport/billedPerAirport-result.js